import type { QSelect } from "quasar"

export const pick = <T extends {}, K extends keyof T>(obj: T, ...keys: K[]) =>
  Object.fromEntries(keys.filter(key => Object.hasOwn(obj, key)).map(key => [key, obj[key]])) as Pick<T, K>

export const pickFn =
  <T extends {}, K extends keyof T>(...keys: K[]) =>
  (obj: T) =>
    pick(obj, ...keys)

export const sortBy = <T extends {}>(...getters: ((obj: T) => string)[]): ((a: T, b: T) => number) => {
  const collator = new Intl.Collator("en")

  return (a: T, b: T) => {
    for (const getter of getters) {
      const comp = collator.compare(getter(a).toLowerCase(), getter(b).toLowerCase())
      if (comp != 0) return comp
    }
    return 0
  }
}

export const storeStyle = (store: { color: string; textColor: string }) => {
  return {
    color: store.textColor.replace(/^(#|)/, "#"),
    backgroundColor: store.color.replace(/^(#|)/, "#")
  }
}

export const mdiUse = (icon: string) => `svguse:mdi/${icon[3]}.svg#${icon}`

export type DoneFn = (callbackFn: () => void, afterFn?: (el: QSelect) => void) => void
